<template>
  <b-field class="option">
    <b-input
      :disabled="!editKeys"
      type="text"
      class="key-field"
      maxlength="32"
      pattern="[a-z0-9_-]+"
      v-model="option.key"
      placeholder="machine key"
      :has-counter="false"
    ></b-input>
    <b-input
      v-if="!useSelectOptions"
      :type="inputType"
      class="value-field"
      size="64"
      maxlength="128"
      v-model="option.value"
      placeholder="display text"
      :title="keyTooltip"
      :has-counter="!integer"
    ></b-input>
    <b-select v-if="useSelectOptions" placeholder="Mode" v-model="option.value" required>
      <option v-for="opt in options" :value="opt.key" :key="['opt',opt.key].join('-')">{{opt.label}}</option>
    </b-select>
    <b-button v-if="mayRemove" @click="remove(index)" icon-left="minus" rounded>remove</b-button>
  </b-field>
</template>

<script>
export default {
  name: "StringKeyValue",
  props: {
    option: {
      type: Object,
      default() {
        return {
          key: "",
          value: ""
        };
      }
    },
    index: {
      type: Number,
      default: -1
    },
    total: {
      type: Number,
      default: -1
    },
    isNew: {
      type: Boolean,
      default: false
    },
    integer: {
      type: Boolean,
      default: false
    },
    editKeys: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    "option.value"(cv, pv) {
      if (this.$parent.$parent.assignOptionKey) {
        if (cv !== pv && cv.length > 1 && this.isNew) {
          this.$parent.$parent.assignOptionKey(this.index, this.key);
        }
      }
    }
  },
  computed: {
    keyTooltip() {
      return "Key: " + this.option.key;
    },
    mayRemove() {
      return this.total > 2;
    },
    inputType() {
      return this.integer ? "number" : "text";
    },
    useSelectOptions() {
      return this.options.length > 1;
    }
  },
  methods: {
    remove() {
      if (this.index >= 0) {
        if (this.$parent.$parent.removeOption) {
          this.$parent.$parent.removeOption(this.index);
        } else if (this.$parent.removeOption) {
          this.$parent.removeOption(this.index);
        }
      }
    }
  }
};
</script>